<template>
  <div class="footer">
    <div class="f-box">
      <div class="header">
          <img v-if="isEnglish" src="../assets/blogo1.png" alt="">
          <img v-else src="../assets/blogo2.png" alt="">
        </div>
      <div class="container">
        <div class="main">
          <div class="left">
            <h5>{{isEnglish ? 'BEIJING WARM&COZY TECHNOLOGY CO.,LTD' : '北京沃慕科技有限公司'}}</h5>
            <h5>business@womutech.com </h5>
            <h5>{{isEnglish ? '2011, Tianheng building, Dongcheng District, Beijing' : '北京市东城区天恒大厦A座2011'}}</h5>
          </div>
          <div class="middle" v-if="!isMobile">
              <h5 @click="goto_about" style="cursor: pointer;">{{isEnglish ? 'About Warm&Cozy' : '关于我们'}}</h5>
              <h5 @click="goto_new" style="cursor: pointer;">{{isEnglish ? 'News' : '新闻'}}</h5>
          </div>
          <div class="right"  v-if="isEnglish">
            <ul>
              <li>
                <div class="img-box">
                  <img src="../assets/erweima11.jpg" alt="">
                </div>
                
                <p style="margin: 0 auto;">Facebook</p>
              </li>
              <li>
                <div class="img-box">
                  <img src="../assets/erweima22.jpg" alt="">
                </div>
                <p style="margin: 0 auto;">WhatsApp</p>
              </li>
            </ul>
          </div>

          <div class="right" v-else>
            <ul>
              <li>
                <div class="img-box">
                  <img src="../assets/erweima112.jpg" alt="">
                </div>
                
                <p style="margin: 0 auto;">扫码关注</p>
              </li>
              <li>
                <div class="img-box">
                  <img src="../assets/erweima222.jpg" alt="">
                </div>
                <p style="margin: 0 auto;">企业客服</p>
              </li>
            </ul>
          </div>
        </div> 
      </div>
    </div>
    <div class="f-bm">
      <div class="f-bmain">
            <span v-if="isEnglish" >Copyright © 2019-2025 Warm&Cozy</span>
            <span v-else>Copyright © 2019-2025 Company 北京沃慕科技有限公司 All rights reserved.</span>
            <span v-if="!isEnglish" style="margin-left: 2em;cursor: pointer;" @click="goto_link">京ICP备2023037347号-2</span>
      </div>
    </div>
  </div>
</template>

<script setup name="FooterBar">
function goto_link() {
  window.open('https://beian.miit.gov.cn/', '_blank'); 
}
import { onMounted, ref, onUnmounted, computed } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();
const isMobile = ref(false);
let isEnglish = ref(window.location.pathname.startsWith('/en'));

onMounted(() => {
  checkmobile();
  window.addEventListener('resize', checkmobile);
});
onUnmounted(() => {
  window.removeEventListener('resize', checkmobile);
});
const checkmobile = () => {
    if (window.innerWidth <= 1024) {
      isMobile.value = true;
    } else {
      isMobile.value = false;
    }
}
function goto_about() {
  if(isEnglish.value){
    router.push('/en/about');
  }else{
    router.push('/about');
  }
}
function goto_new() {
  if(isEnglish.value){
    router.push('/en/news');
  }else{
    router.push('/news');
  }
}
</script>

<style scoped>

.footer{
  background-color: #131A28;
  margin-top: 5em;
  overflow: hidden;
}
.f-box{
  width: 60%;
  margin: 2em auto;
}
.header{
  margin: 2em 0 2em 0;
}
.header img{
  width: 8em;
}
.main{
  display: flex;
  justify-content:space-between
}
.main .left,.main .middle{
  color:#fff;
}
.main .left{
  width: 35%;
}
.main .middle{
  width: 25%;
  display: flex;
  justify-content: space-around;
  margin-top: 2.8%;
  margin-right: 3em;
}
.main .left h5{
  margin-bottom: 1em;
}
.main .middle>ul{
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.main .middle>ul li{
  list-style: none;
}
.main .middle>ul li>ul{
  margin-top: 1em;
}
.main .middle>ul li{
  font-size: 12px;
  line-height: 3em;
}
.main .right{
  width: 20%;
  margin-top: -2%;
  text-align: center;
}
.main .right>ul{
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.main .right>ul li{
  width: 40%;
  list-style: none;
  color: #fff;
  margin-top: 1em;
}
.main .right>ul li .img-box{
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #fff;
}
.main .right>ul li .img-box img{
  width: 90%;
  margin: 0.2em auto;
}
.f-bm{
  width: 100%;
  height: 4em;
  margin:0 auto;
  margin-top: 1em;
  text-align: center;
  border-top:1px solid #FFFFFF ;
}
.f-bm .f-bmain{
  width: 100%;
  text-align: center;
  margin: 0 auto;
}
.f-bm .f-bmain span{
  color: #fff;
  font-size: 12px;
}
@media (max-width: 1024px) {
  .f-box {
    width: 90%; 
  }
  .main {
    flex-direction: column; 
    align-items: left;
  }
  .main .left, .main .middle, .main .right {
    width: 100%; 
    margin-bottom: 2em; 
    text-align: left !important; 
  }
  .main .middle {
    margin-top: 0; 
    justify-content: left;
  }
  .main .middle h5:last-child {
    margin-left: 1em;
  }
  .main .right {
    width: 60%;
    margin: 0 auto;
  }
  .main .right>ul li {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 1em; 
    text-align: center;
  }
  .main .right>ul li .img-box{
    width: 100%;
  }
  .main .right>ul li .img-box img{
    width: 90%;
  }
  .main .right>ul li p{
    width: 100%;
    font-size: 0.5em;
  }
  .f-bm {
    height: auto; 
    padding: 1em 0;
  }
  .f-bm .f-bmain{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .f-bm .f-bmain span:first-child {
    margin:0 4em;
  }
}
</style>